import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PipelineFeatureProperties, PointOGIMGeoJSONProperties } from '../../../../../types';
import { selectEmissionsMapInfraOperatorFilter } from '../../../../../reducers';

// check if the current OGI feature should be hidden or not, based on if the operator filter is selected and if the OGI feature
// has that operator. Hidden OGI will never be reopened within this drawer instance, even if the operator filter changes.
export function useOperatorCheck({
    ogiMetaData,
    filterCards,
    id
}: {
    ogiMetaData: PipelineFeatureProperties | PointOGIMGeoJSONProperties | undefined;
    filterCards: (id: string | number) => void;
    id: number | string;
}) {
    const selectedOperators = useSelector(selectEmissionsMapInfraOperatorFilter);

    // if the selected operators have been updated, compare and remove this ogim_id from the card list if
    // it is one of the selected operators
    useEffect(() => {
        if (!ogiMetaData || !selectedOperators.length) return;
        const { operators } = ogiMetaData;

        const operatorIDs = new Set(selectedOperators.map((operator) => operator.id));

        // find if any of the operators tied to this OGI is selected
        const selectedOperator = operators?.some((currentOGIOperator) => {
            return currentOGIOperator?.operator_id && operatorIDs.has(currentOGIOperator.operator_id);
        });

        // if not selected, then filter this card from the list
        if (!selectedOperator && id === ogiMetaData.ogim_id) {
            filterCards(id);
        }
    }, [ogiMetaData, selectedOperators, filterCards, id]);
}
